const mobileWidth = 1050
const edge = 0.15

const boxes = [...document.querySelectorAll('.produkte .images')]

boxes.forEach(box => {
	const images = [...box.querySelectorAll('img')]
	const count = images.length
	const show = i => images.forEach((img,n) => img.classList.toggle('active', n <= i))
	if (!count) return
	show(0)
	box.onmousemove = e => {
		if (window.innerWidth <= mobileWidth) return
		const r = box.getBoundingClientRect()
		const x = e.clientX - r.left
		if (x < 0 || x > r.width) return
		show(Math.min(count - 1, Math.floor(x / (r.width / count))))
	}
})

const updateMobile = box => {
	if (window.innerWidth > mobileWidth) return
	const item = box.closest('.item')
	const images = [...box.querySelectorAll('img')]
	const count = images.length
	const r = item.getBoundingClientRect()
	const w = window.innerWidth
	const visible = Math.min(r.right,w) - Math.max(r.left,0)
	if (visible < r.width) return
	const p = (w / 2 - r.left) / r.width
	if (p < edge || p > 1 - edge) return
	const i = Math.min(count - 1, Math.max(0, Math.floor((p - edge) / ((1 - edge * 2) / count))))
	images.forEach((img,n) => img.classList.toggle('active', n <= i))
}

const observer = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		if (entry.isIntersecting) updateMobile(entry.target.querySelector('.images'))
	})
},{ threshold: 1 })

boxes.forEach(box => observer.observe(box.closest('.item')))
window.addEventListener('scroll', () => boxes.forEach(updateMobile), { passive: true })
document.querySelector('.produkte .items')?.addEventListener('scroll', () => boxes.forEach(updateMobile), { passive: true })
window.addEventListener('resize', () => boxes.forEach(updateMobile))